import { useTranslate } from "ra-core";
import { useNavigate } from "react-router";

import { morphTriggerSelector } from "../layout/closeButtonPlacement";
import { useMobileChrome } from "../layout/MobileChrome";
import { MOBILE_CALENDAR_PATH } from "../layout/mobileModules";
import { MorphWindow } from "../layout/MorphWindow";
import { WINDOW_STATE_KEY } from "../layout/useWindowHistory";
import { UpcomingAgenda } from "./UpcomingAgenda";

/**
 * «Hoy y próximos»: a quick look at today and the next few days, as a
 * full-screen window grown from the top-bar calendar button. The full
 * calendar (month / week / agenda) is one tap away, on its own page.
 */
export const AgendaWindow = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { activeWindow, closeWindow } = useMobileChrome();

  // The window's own history entry (useWindowHistory) is replaced by the
  // calendar: the route change closes the window, and Back from the
  // calendar returns to the page under it, not to the window.
  const openCalendar = () => {
    const state = window.history.state as Record<string, unknown> | null;
    navigate(MOBILE_CALENDAR_PATH, {
      replace: state?.[WINDOW_STATE_KEY] === "agenda",
    });
  };

  return (
    <MorphWindow
      open={activeWindow === "agenda"}
      onClose={closeWindow}
      trigger={morphTriggerSelector("agenda")}
      title={translate("crm.mobile.upcoming.title")}
      closeLabel={translate("crm.mobile.upcoming.close")}
      testId="mobile-agenda-window"
    >
      <UpcomingAgenda onOpenCalendar={openCalendar} />
    </MorphWindow>
  );
};
